module.exports = __webpack_public_path__ + "fonts/icomoon.10b1efc.ttf";